import {
    authenticatedApi,
    ApiError,
    API_BASE_URL
} from './apiUtils';

export const tagsApi = {
  getAllTags: async () => {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/tags`);
    } catch (error) {
      throw new ApiError('Failed to fetch tags', error.status || 500);
    }
  },

  getTagHierarchy: async () => {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/tags/hierarchy`);
    } catch (error) {
      throw new ApiError('Failed to fetch tag hierarchy', error.status || 500);
    }
  },

  createTag: async (tagData) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/tags`, tagData);
    } catch (error) {
      throw new ApiError('Failed to create tag', error.status || 500);
    }
  },

  updateTag: async (tagId, tagData) => {
    try {
      return await authenticatedApi.put(`${API_BASE_URL}/tags/${tagId}`, tagData);
    } catch (error) {
      throw new ApiError('Failed to update tag', error.status || 500);
    }
  },

  deleteTag: async (tagId) => {
    try {
      return await authenticatedApi.delete(`${API_BASE_URL}/tags/${tagId}`);
    } catch (error) {
      throw new ApiError('Failed to delete tag', error.status || 500);
    }
  },

  getTagsByLeafId: async (leafSegmentId) => {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/leaf-segments/${leafSegmentId}/tags`);
    } catch (error) {
      throw new ApiError('Failed to fetch tags for leaf segment', error.status || 500);
    }
  },
};
